import { render, staticRenderFns } from "./WHlist.vue?vue&type=template&id=3997eb52&scoped=true"
import script from "./WHlist.vue?vue&type=script&lang=js"
export * from "./WHlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3997eb52",
  null
  
)

export default component.exports